import { Link, useLocation, type LinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { resolveLocalizedTo } from '@/i18n/routes'

function scrollToTop() {
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  window.scrollTo({ top: 0, left: 0, behavior })
}

export function LocalizedLink({ to, onClick, ...props }: Omit<LinkProps, 'to'> & { to: string }) {
  const { i18n } = useTranslation('common')
  const location = useLocation()
  const path = resolveLocalizedTo(to, i18n.resolvedLanguage === 'en' ? 'en' : 'it')
  if (/^(https?:|mailto:|tel:)/.test(path)) return <a href={path} onClick={onClick} {...props} />

  const handleClick: LinkProps['onClick'] = event => {
    onClick?.(event)
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || props.target === '_blank') return

    const destination = new URL(path, window.location.href)
    const linksToCurrentPage = destination.pathname === location.pathname && !destination.hash

    if (linksToCurrentPage) {
      if (destination.search === location.search) event.preventDefault()
      scrollToTop()
    }
  }

  return <Link to={path} viewTransition onClick={handleClick} {...props} />
}
